import {SVGProps} from 'react'

const ChevronIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 15.3287L6.34625 9.675L7.275 8.74625L12 13.4712L16.725 8.74625L17.6538 9.675L12 15.3287Z" fill="currentColor" />
  </svg>
)

export default ChevronIcon
